export default __webpack_public_path__ + "static/media/productHealthCheckPackage1_En.69c25b39.webp";